export * from './IconPermeabilityMap';
